import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils'

class BillAdmin {
  /* 获取费用类型列表 */
  static getCostTypeList() {
    let url = `/zzd/api/back/bill/type/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取发票类型 */
  static getInvoiceTypeList() {
    let url = `/zzd/api/back/receipt/type/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取费用表单设置详情 */
  static getCostDetailsList(billType) {
    let url = `/zzd/api/back/bill/template/detail?billType=${billType}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑费用单模板 */
  static postModCost(data) {
    let url = `/zzd/api/back/bill/template/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }

  /* 获取报销单类型列表 */
  static getReimbursementTypeList(queryStr) {
    let url = `/zzd/api/back/reimburse/list?queryStr=${queryStr}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取单据详情 */
  static getReimbursementDetails(id) {
    let url = `/zzd/api/back/reimburse/detail/${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除报销单 */
  static getDelReimbursementTypeList(data) {
    let url = `/zzd/api/back/reimburse/delete`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增报销单 */
  static postAddReimbursement(data) {
    let url = `/zzd/api/back/reimburse/add/name`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取出纳列表 */
  static getCashierList(teamId) {
    let url = `/zzd/api/back/biz/role/list/cashier/team?teamId=${teamId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }

  /* 修改报销单名称 */
  static postModReimbursementName(data) {
    let url = `/zzd/api/back/reimburse/update/name`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑报销单 */
  static postModReimbursement(data) {
    let url = `/zzd/api/back/reimburse/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  
  /* 预审批单类型 */
  static getPreliminaryTypeList(queryStr) {
    let url = `/zzd/api/back/pre/list?queryStr=${queryStr}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 修改预算审批单单据名称 */
  static postPreliminaryBillName(data) {
    let url = `/zzd/api/back/pre/update/name`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除预审批单模板 */
  static postDelPreliminary(data) {
    let url = `/zzd/api/back/pre/delete`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除预审批单类型 */
  static postDelPreliminaryType(data) {
    let url = `/zzd/api/back/pre/delete/type`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增预审批单类型 */
  static postAddPreliminaryType(data) {
    let url = `/zzd/api/back/pre/add/type`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 预审批单重命名 */
  static postModPreliminaryType(data) {
    let url = `/zzd/api/back/pre/update/type/name`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增预审批单单据名称 */
  static postAddPreliminaryBillName(data) {
    let url = `/zzd/api/back/pre/add/name`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取预审批单详情 */
  static getPreliminaryDetails(id) {
    let url = `/zzd/api/back/pre/detail/${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取固定预审批单详情 */
  static getFixedPreliminaryDetails(id) {
    let url = `/zzd/api/back/pre/fixed/detail/${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑预审批单 */
  static postModPreliminary(data) {
    let url = `/zzd/api/back/pre/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  
  /* 新增自定义预审批单模板 */
  static postAddPreliminary(data) {
    let url = `/zzd/api/back/pre/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }

  /* 获取打印控件列表 --- 除自定义模板以外 */
  static getPrintContralList(type, typeId) {
    let url = `/zzd/api/back/print/template/control/list?type=${type}&typeId=${typeId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取打印控件列表 --- 自定义模板 */
  static getPrintContralCustomList(formId) {
    let url = `/zzd/api/back/print/template/control/customize/list?formId=${formId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取打印详情 */
  static getPrintDetails(options) {
    let url = `/zzd/api/back/print/template/detail?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存打印模板 */
  static postSavePrint(data) {
    let url = `/zzd/api/back/print/template/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }

  
}

export default BillAdmin;